<div class="vox-inline-message vox-inline-message_light-grey">
  <div>
    <i class="icon-small-info"></i>
    <span [innerHTML]="'equipment.filters.info' | translate"></span>
  </div>
</div>
<div class="equipment-filter" *ngIf="form">
    <form [formGroup]="form" class="equipment-filter__form">
      <div class="equipment-filter__filter" *ngFor="let used of usedFilters; let uIdx = index">
        <button class="equipment-filter__filter-remove  vox-btn vox-btn-secondary-grey"
          type="button"
          (click)="removeFilter(uIdx)"
          [ngClass]="{'hidden': usedFilters.length === 1}"
          [disabled]="!canRemoveFilter(uIdx)">
          <i class="equipment-filter__filter-remove_symbol icon-small-remove"></i>
        </button>
        <div ngbDropdown class="equipment-filter__filter-dropdown">
          <button class="vox-btn vox-btn-secondary equipment-filter__filter-dropdown_btn"
            id="equipment-filter-dropdown-{{uIdx}}"
            ngbDropdownToggle
            [disabled]="availableFilters.length < 1 || !canRemoveFilter(uIdx)"
            >
            {{'equipment.filters.' + used | translate}}
          </button>
          <div class="equipment-filter__filter-dropdown_menu" ngbDropdownMenu aria-labelledby="equipment-filter-dropdown">
            <button ngbDropdownItem class="equipment-filter__filter-dropdown_item"
              type="button"
              *ngFor="let filter of availableFilters; let idx = index"
              [disabled]="disabledItem && (filter === 'macAddress' || filter === 'ipui')"
              (click)="updateFilters(idx, uIdx)">
              {{'equipment.filters.' + filter | translate}}
            </button>
          </div>
          <div class="equipment-filter__filter-input" [ngSwitch]="used">
            <div class="equipment-filter__filter-input vox-input-group vox-input-group_dense">
              <input *ngSwitchCase="'macAddress'"
                class="vox-text-field"
                type="text"
                formControlName="macAddress"
                (keydown.enter)="emitFilters(); $event.preventDefault(); $event.stopPropagation();">
              <i *ngIf="form.get('macAddress') && form.get('macAddress').valid && form.get('macAddress').dirty"
                class="vox-text-field__icon vox-text-field__icon_valid icon-small-check"></i>
            </div>
            <div class="equipment-filter__filter-input vox-input-group vox-input-group_dense">
              <input *ngSwitchCase="'ipui'"
                class="vox-text-field"
                type="text"
                formControlName="ipui"
                (keydown.enter)="emitFilters(); $event.preventDefault(); $event.stopPropagation();">
              <i *ngIf="form.get('ipui') && form.get('ipui').valid && form.get('ipui').dirty"
                class="vox-text-field__icon vox-text-field__icon_valid icon-small-check"></i>
            </div>
            <div class="equipment-filter__filter-input vox-input-group vox-input-group_dense">
              <gdp-select-model formControlName="model" *ngSwitchCase="'model'" [modelList]="models"></gdp-select-model>
            </div>
            <div class="equipment-filter__filter-input vox-input-group vox-input-group_dense">
              <input *ngSwitchCase="'alphaname'"
                [readonly]="!canRemoveFilter(uIdx)"
                (keydown.enter)="emitFilters(); $event.preventDefault(); $event.stopPropagation();"
                formControlName="alphaname"
                class="vox-text-field"
                type="text">
            </div>
            <div class="equipment-filter__filter-input vox-input-group vox-input-group_dense">
              <input *ngSwitchCase="'pbxId'"
                [readonly]="!canRemoveFilter(uIdx)"
                formControlName="pbxId"
                (keydown.enter)="emitFilters(); $event.preventDefault(); $event.stopPropagation();"
                class="vox-text-field"
                type="text">
            </div>
          </div>
        </div>
      </div>
      <div class="equipment-filter__filter-add_container">
        <button class="vox-btn vox-btn-secondary equipment-filter__filter-add"
          type="button"
          (click)="addFilter(0)"
          [disabled]="availableFilters.length < 1 || limitedAvailableFilters.length < 1 || isDisabledAddFilters()">
          <i class="equipment-filter__filter-add_symbol icon-small-add">
          </i>
        </button>
        <button class="vox-btn vox-btn-secondary equipment-filter__filter-apply"
          type="submit"
          (click)="emitFilters()"
          [disabled]="form.invalid">
          {{'equipment.actions.apply-filters' | translate}}
        </button>
        <button class="ml-2 btn btn-link equipment-filter__filter-clear"
          type="button"
          (click)="resetFilters()">
          {{'equipment.actions.clear-filters' | translate}}
        </button>
      </div>
    </form>
</div>
